<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'UseCasesModule',
  props: {
    options: {
      type: Object,
      default: _ => {},
    },
  },
  data() {
    return {
      isMobile: isMobile,
    }
  },
}
</script>
